var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiltersquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.38 18.9C11.05 18.9 10.72 18.82 10.42 18.65C9.81 18.31 9.44 17.69 9.44 16.99V13.91C9.44 13.72 9.29 13.35 9.14 13.16L6.97 10.88C6.56 10.47 6.25 9.75002 6.25 9.20002V7.87002C6.25 6.76002 7.09 5.90002 8.16 5.90002H15.83C16.88 5.90002 17.74 6.76002 17.74 7.81002V9.09002C17.74 9.79002 17.34 10.56 16.94 10.96L14.41 13.2C14.25 13.34 14.08 13.69 14.08 13.98V16.48C14.08 17.11 13.7 17.81 13.19 18.11L12.4 18.62C12.09 18.81 11.74 18.9 11.38 18.9ZM8.16 7.40002C7.92 7.40002 7.75 7.60002 7.75 7.87002V9.20002C7.75 9.33002 7.89 9.67002 8.05 9.83002L10.27 12.17C10.61 12.6 10.94 13.29 10.94 13.91V16.99C10.94 17.19 11.07 17.3 11.15 17.34C11.26 17.4 11.44 17.44 11.6 17.34L12.4 16.82C12.48 16.76 12.58 16.56 12.58 16.46V13.96C12.58 13.25 12.93 12.46 13.43 12.05L15.91 9.85002C16.04 9.72002 16.24 9.32002 16.24 9.07002V7.81002C16.24 7.59002 16.05 7.40002 15.83 7.40002H8.16Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z",
    fill: "#292D32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiltersquare);
export default __webpack_public_path__ + "static/media/filtersquare.fc7aae66a6558709fec6b675bbfb14f9.svg";
export { ForwardRef as ReactComponent };